import * as singleSpa from '@unicloud/single-spa';
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import Http from './utils/httpConf';
import './commonDep';
import { GlobalEventDistributor } from './globalEventDistributor';
import { storeInstance } from './singleSpaStore';
import { loadApp } from './loadApp';
import Element from '@unicloud/element-ui';
import '@unicloud/element-ui/lib/theme-chalk/index.css';
import initGlobalStore from './singleSpaStore';
import './assets/style/common.scss';

Vue.config.productionTip = false
Vue.use(Element, {size: 'small'});
Vue.use(Http);

if (!localStorage.getItem('token')) {
  let userInfo = JSON.parse(localStorage.getItem('user'));
  if (userInfo && userInfo.type == 'PUBLIC') {
    window.location.href = `/login`;
  } else if (userInfo && userInfo.type == 'CHILD') {
    window.location.href = `/iam/login`;
  } else {
    window.location.href = `/login`;
  }
}

const projectConfigPath = GLOBAL.isDev ? `static/js/project.config.js` : `project.config.js`;

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')

async function getProjectConfig() {
  return SystemJS.import(projectConfigPath);
}

async function init() {
  const globalEventDistributor = new GlobalEventDistributor();
  const loadingPromises = [];

  const projectConfig = await getProjectConfig();

  store.state.globalEventDistributor = globalEventDistributor;
  initGlobalStore(store);

  Object.keys(projectConfig).forEach(projectName => {
    let microProject = projectConfig[projectName];
    loadingPromises.push(loadApp({
      name: microProject.name,
      appURL: microProject.main,
      base: microProject.base,
      globalEventDistributor: globalEventDistributor
    }));
  })

  // 等待所有子项目app以及store加载完毕
  // await Promise.all(loadingPromises);

  // 启动singleSPA
  singleSpa.start();
}

init();
